module.exports = __webpack_public_path__ + "img/antenna.c7715f02.svg";